import { Box, Container, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";

const ProgramDetails = () => (
	<Box w="full" bgColor="#EEFFF3">
		<Container maxW="container.lg">
			<Box padding={{ xs: "50px 0px", md: "60px 50px 56px" }} mt="10px">
				<Text
					fontWeight="700"
					fontSize={{ xs: "26px", md: "36px" }}
					lineHeight="130%"
					color="#197542"
					textAlign="left"
					mb="2.5rem"
					borderLeft="3px solid #197542"
					pl="10px"
				>
					Program Details
				</Text>

				<Text
					fontWeight="600"
					fontSize={{ xs: "14px", md: "24px" }}
					lineHeight="150%"
					mb="2rem"
					letterSpacing="0.02em"
					color="#010E04"
				>
					IVCA GreenReturns Summit aims to serve as a crucial crucible for
					facilitating dialogues and interactions for climate finance to find
					the appropriate investments and it is set to take place on:
				</Text>

				<Flex
					justify="center"
					flexDirection={{
						xs: "column",
						md: "row",
					}}
					gap={6}
				>
					{/* {data.map((item) => ( */}
					<Box
						display="flex"
						flexDirection="column"
						justifyContent="space-evenly"
						px={3}
						py={6}
						borderWidth="1px"
						borderRadius="4px"
						textAlign="center"
						bg="white"
						w="full"
						alignItems="center"
						boxShadow="4px 4px 4px 0px #98CAA7"
					>
						<Image
							w="56px"
							mb="12px"
							mx="auto"
							src="https://static.levocdn.com/WGLBUT82/icons8-survey1-BwjJoG7tUWv0.png"
						/>
						<Flex
							flexDirection="column"
							alignItems="start"
							justifyContent="start"
						>
							<Text
								fontSize={{ xs: "14px", md: "18px" }}
								color="#010E04"
								fontWeight="600"
							>
								Day 1- 2nd December 2024
							</Text>
							<Text
								fontSize={{ xs: "14px", md: "18px" }}
								color="#010E04"
								fontWeight="600"
							>
								Day 2- 3rd December 2024
							</Text>
						</Flex>
						<Text
							fontSize={{ xs: "12px", md: "16px" }}
							mt="12px"
							color="#46564A"
						>
							Date
						</Text>
					</Box>
					{/* 2 */}
					<Box
						display="flex"
						flexDirection="column"
						justifyContent="space-evenly"
						px={3}
						py={6}
						borderWidth="1px"
						borderRadius="4px"
						textAlign="center"
						bg="white"
						alignItems="center"
						w="full"
						boxShadow="4px 4px 4px 0px #98CAA7"
					>
						<Image
							w="56px"
							mb="12px"
							mx="auto"
							src="https://static.levocdn.com/WGLBUT82/timesvgrepocom-4JOVlpcY6zo7.png"
						/>
						<Flex
							flexDirection="column"
							alignItems="start"
							justifyContent="start"
						>
							<Text
								fontSize={{ xs: "14px", md: "18px" }}
								color="#010E04"
								fontWeight="600"
							>
								Day 1- 12:00PM - 8:00PM
							</Text>
							<Text
								fontSize={{ xs: "14px", md: "18px" }}
								color="#010E04"
								fontWeight="600"
							>
								Day 2- 09:00AM - 9:00PM
							</Text>
						</Flex>
						<Text
							fontSize={{ xs: "12px", md: "16px" }}
							mt="12px"
							color="#46564A"
						>
							Timings
						</Text>
					</Box>
					<Box
						display="flex"
						flexDirection="column"
						justifyContent="space-evenly"
						px={3}
						py={6}
						borderWidth="1px"
						borderRadius="4px"
						textAlign="center"
						bg="white"
						w="full"
						boxShadow="4px 4px 4px 0px #98CAA7"
					>
						<Image
							w="56px"
							mb="12px"
							mx="auto"
							src="https://static.levocdn.com/WGLBUT82/location-pinsvgrepocom-rSC4lHZmfIO5.png"
						/>
						<Text
							fontSize={{ xs: "14px", md: "18px" }}
							color="#010E04"
							fontWeight="600"
						>
							Taj Palace Hotel <br />
							New Delhi
						</Text>
						<Text
							fontSize={{ xs: "12px", md: "16px" }}
							mt="12px"
							color="#46564A"
						>
							Location
						</Text>
					</Box>
					{/* ))} */}
				</Flex>
			</Box>
		</Container>
	</Box>
);

export default ProgramDetails;
